// locale for studio

import safeLoadLocale from '@cdo/apps/util/safeLoadLocale';

let locale = safeLoadLocale('studio_locale');
module.exports = locale;
